module.exports = __webpack_public_path__ + "img/camp_shirt_other8.d0ca8059.svg";